import UsersTable from "./users-table";

export default UsersTable;
